import React, {
    useState,
} from "react";
import { Card, CardContent } from "@mui/material";
import {Download} from "react-feather";
import Tab from "../../components/Tab";
import "react-toastify/dist/ReactToastify.css";
import {
    FORMS,
    MODULES,
} from "../../const";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import MISReportScreen from "../../components/transaction/mis-report/MISReportScreen";

const form = FORMS.MIS.REPORT.form;

function MISReport() {
    useParams();
    useSelector(
        (state) => state.user.permissions[MODULES.Transaction],
    );
    const [tab, setTab] = useState(1);

    return (
        <div>
            <Card>
                <CardContent>
                    <div className="ui tabular menu top attached">
                        <Tab
                            Icon={Download}
                            onClick={() => {
                                setTab(1);
                            }}
                            active={tab === 1}
                            label="MIS Report"
                        />
                    </div>
                    <>
                        <div
                            className="ui bottom attached active tab segment"
                            style={{ display: tab === 1 ? "block" : "none" }}
                        >
                            <MISReportScreen />
                        </div>
                    </>
                </CardContent>
            </Card>
        </div>
    );
}

export default MISReport;
